/* eslint-disable react-hooks/rules-of-hooks */
import { Operator } from '@jexop/core';
import { isString } from 'lodash';
import { useFlags } from '../components';

export const ifFlag: Operator<boolean> = ({ flag }): boolean => {
  const flags = useFlags();

  if (isString(flag) && flags[flag] === true) {
    return true;
  }

  return false;
};
